import React from 'react';
import styled from 'styled-components';
import { PrimaryButton } from '../../../components/Buttons';
import trainingService from '../../../services/trainingService';
import {
  Container,
  Description,
  Subtitle,
  TitleContainer,
  TrainingName,
  TrainingPosterContainer,
} from './RequireOrgForTrainingViewElements';
import { TrainingPoster } from './TrainingHeader';

const SetupButton = styled(PrimaryButton)`
  min-width: 200px;
`;

type NoOrgViewProps = {
  trainingName: string;
  trainingPosterImage?: string;
  onContinueSetup: () => void;
};

export const NoOrgView = ({ trainingName, trainingPosterImage, onContinueSetup }: NoOrgViewProps) => {
  return (
    <Container>
      {trainingPosterImage ? (
        <TrainingPosterContainer>
          <TrainingPoster src={trainingService.getTrainingImageUrl(trainingPosterImage)} alt={trainingName} />
        </TrainingPosterContainer>
      ) : (
        <TitleContainer>
          <Subtitle>Get ready to start</Subtitle>
          <TrainingName>{trainingName}</TrainingName>
        </TitleContainer>
      )}

      <Description>
        Welcome! Let&apos;s make sure your church is set up properly to share and assign {trainingName}. We will ask you
        to confirm or provide some church information before you start so that we can serve you better.
      </Description>

      <SetupButton onClick={onContinueSetup}>Continue Church Setup</SetupButton>
    </Container>
  );
};
